<template>
  <div class="gWidth detail_box">
    <div class="detail_L">
      <span>
        <el-popover
          trigger="hover"
          placement="right"
          width="150"
          v-model:visible="visible"
        >
          <div id="qrCode" ref="qrCodeDiv"></div>
          <template #reference>
            <span class="cuP" style="margin-top: -1px"
              ><i class="el-icon-s-promotion activeY1"></i>分享</span
            >
          </template>
        </el-popover>
      </span>
      <span
        ><i class="el-icon-star-on activeLL" style="font-size: 50px"></i
        >收藏</span
      >
    </div>
    <el-card class="detail_R">
      <h2 class="title">
        {{ detail_l.home_team_name }}
        {{
          detail_l.match_state === -1
            ? detail_l.home_score + '-' + detail_l.guest_score
            : $filters.match_state(detail_l.match_state)
        }}
        {{ detail_l.guest_team_name }}
      </h2>
      <b class="detail_h">
        {{ detail_l.public_time }} (笔记类型:{{
          note_types[detail_l.note_type]
        }})<span class="activeR">
          {{
            detail_l.two_choice == null
              ? detail_l.note_type == 1
                ? `单选:${choice_type[detail_l.first_choice]}`
                : detail_l.note_type == 2
                ? `单选:主${
                    detail_l.goal > 0 ? `+${detail_l.goal}` : detail_l.goal
                  }${choice_type[detail_l.first_choice]}`
                : detail_l.note_type == 3
                ? `单选:${
                    detail_l.goal > 0 ? `+${detail_l.goal}` : detail_l.goal
                  }${detail_l.first_choice == 3 ? '大球' : '小球'}`
                : ''
              : `首选:${choice_type[detail_l.first_choice]}&nbsp;&nbsp;&nbsp;`
          }}{{
            detail_l.two_choice != null
              ? `次选:${choice_type[detail_l.two_choice]}`
              : ''
          }}
        </span>
        <span
          class="icon_mm"
          v-if="
            detail_l.first_choice >= 0 &&
            'first_choice' in detail_l &&
            detail_l.match_state === -1
          "
        >
          <svg
            v-if="detail_l.first_result == 1 || detail_l.two_result == 1"
            class="icon"
            aria-hidden="true"
          >
            <use xlink:href="#icon-hit"></use>
          </svg>
          <svg v-else class="icon" aria-hidden="true">
            <use xlink:href="#icon-weimingzhong"></use>
          </svg>
        </span>
      </b>
      <el-divider></el-divider>
      <div v-html="detail_l.content"></div>
    </el-card>
  </div>
</template>
<script>
import { ref, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import QRCode from 'qrcodejs2'
import '../../assets/font/iconfont'
export default {
  setup() {
    let { proxy: _this } = getCurrentInstance()
    let router = useRouter()
    let note_id = router.currentRoute.value.params.note_id
    // console.log(news_id)
    // 初始新闻详情
    let detail_l = ref([])
    let soccer_news = async () => {
      let { data: res } = await _this.$http.get(
        `/soccer/match_notes/${note_id}`
      )
      // 7665
      res.data.content = res.data.content.replace(/href/g, 'aaa')
      detail_l.value = res.data
    }
    soccer_news()
    // 二维码生成
    console.log(router.currentRoute.value.fullPath)
    let qrCodeDiv = ref('')
    let qrcode = () => {
      setTimeout(() => {
        new QRCode(
          qrCodeDiv.value,
          {
            text: `http://deyity.com${router.currentRoute.value.fullPath}`,
            width: 150,
            height: 150,
            colorDark: '#333333', // 二维码颜色
            colorLight: '#ffffff', // 二维码背景色
            correctLevel: QRCode.CorrectLevel.H // 容错率L/M/H
          },
          100
        )
      })
    }
    qrcode()
    return {
      detail_l,
      qrCodeDiv,
      visible: ref(false),
      note_types: {
        1: '胜平负',
        2: '让球',
        3: '大小球'
      },
      choice_type: {
        3: '胜',
        1: '平',
        0: '负'
      }
    }
  }
}
</script>
<style lang="less">
.detail_box {
  width: 1010px;
  display: flex;
  justify-content: space-between;
}
.detail_L {
  width: 100px;
  height: 200px;
  background: #fff;
  display: flex;
  flex-direction: column;
  span {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    margin-top: 20px;
    i {
      font-size: 40px;
    }
  }
}
.detail_R {
  width: 900px;
  .title {
    text-align: center;
    color: #444;
  }
  b {
    font-size: 14px;
    display: block;
    text-align: center;
    color: #606266;
  }
  p {
    // text-indent: 2em;
    // line-height: 26px;
    margin: 20px 0 !important;
  }
  .detail_h {
    position: relative;
    .icon_mm {
      position: absolute;
      right: 10px;
      top: -80px;
      .icon {
        width: 80px;
      }
    }
  }
}
</style>
